import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSina = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#sina_svg__a)'>
      <path
        fill='#008AD1'
        fillRule='evenodd'
        d='m5.54 20.616.68.399L11.48 24l5.26-2.985L22 18.03V6.09l-3.816-2.217L12.27 7.34l3.762 2.135v5.167z'
        clipRule='evenodd'
      />
      <path
        fill='#008AD1'
        fillRule='evenodd'
        d='m17.46 3.383-.68-.398L11.52 0 6.26 2.985 1 5.97v11.94l3.816 2.217 5.914-3.468-3.762-2.135V9.357z'
        clipRule='evenodd'
      />
      <path
        fill='#E6B500'
        d='M11.99 15.275c1.85-.37 3.043-2.145 2.666-3.963s-2.182-2.991-4.031-2.62c-1.85.37-3.044 2.144-2.667 3.962s2.182 2.991 4.032 2.62'
      />
    </g>
    <defs>
      <clipPath id='sina_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgSina)
export default ForwardRef
